var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "14",
        height: "18",
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_128_70578)" } }, [
        _c("path", {
          attrs: {
            d: "M7.00053 0C5.57553 0 4.3619 0.910227 3.91531 2.18182H2.6369C1.43349 2.18182 0.455078 3.16023 0.455078 4.36364V15.2727C0.455078 16.4761 1.43349 17.4545 2.6369 17.4545H11.3642C12.5676 17.4545 13.546 16.4761 13.546 15.2727V4.36364C13.546 3.16023 12.5676 2.18182 11.3642 2.18182H10.0858C9.63917 0.910227 8.42553 0 7.00053 0ZM7.00053 2.18182C7.28986 2.18182 7.56734 2.29675 7.77192 2.50134C7.97651 2.70592 8.09144 2.9834 8.09144 3.27273C8.09144 3.56205 7.97651 3.83953 7.77192 4.04412C7.56734 4.2487 7.28986 4.36364 7.00053 4.36364C6.71121 4.36364 6.43373 4.2487 6.22914 4.04412C6.02456 3.83953 5.90962 3.56205 5.90962 3.27273C5.90962 2.9834 6.02456 2.70592 6.22914 2.50134C6.43373 2.29675 6.71121 2.18182 7.00053 2.18182ZM2.90962 9.27273C2.90962 9.05573 2.99582 8.84762 3.14926 8.69419C3.3027 8.54075 3.51081 8.45455 3.72781 8.45455C3.9448 8.45455 4.15291 8.54075 4.30635 8.69419C4.45979 8.84762 4.54599 9.05573 4.54599 9.27273C4.54599 9.48972 4.45979 9.69783 4.30635 9.85127C4.15291 10.0047 3.9448 10.0909 3.72781 10.0909C3.51081 10.0909 3.3027 10.0047 3.14926 9.85127C2.99582 9.69783 2.90962 9.48972 2.90962 9.27273ZM6.45508 8.72727H10.8187C11.1187 8.72727 11.3642 8.97273 11.3642 9.27273C11.3642 9.57273 11.1187 9.81818 10.8187 9.81818H6.45508C6.15508 9.81818 5.90962 9.57273 5.90962 9.27273C5.90962 8.97273 6.15508 8.72727 6.45508 8.72727ZM2.90962 12.5455C2.90962 12.3285 2.99582 12.1204 3.14926 11.9669C3.3027 11.8135 3.51081 11.7273 3.72781 11.7273C3.9448 11.7273 4.15291 11.8135 4.30635 11.9669C4.45979 12.1204 4.54599 12.3285 4.54599 12.5455C4.54599 12.7625 4.45979 12.9706 4.30635 13.124C4.15291 13.2774 3.9448 13.3636 3.72781 13.3636C3.51081 13.3636 3.3027 13.2774 3.14926 13.124C2.99582 12.9706 2.90962 12.7625 2.90962 12.5455ZM5.90962 12.5455C5.90962 12.2455 6.15508 12 6.45508 12H10.8187C11.1187 12 11.3642 12.2455 11.3642 12.5455C11.3642 12.8455 11.1187 13.0909 10.8187 13.0909H6.45508C6.15508 13.0909 5.90962 12.8455 5.90962 12.5455Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_128_70578" } }, [
          _c("rect", { attrs: { width: "14", height: "18", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }